import styled from 'styled-components';

const StepStyle = styled.section`
  width: 100%;
  background: #f2fff7;
  padding-bottom: 50px;

  > div {
    flex-direction: column;
  }

  h2 {
    color: #93da49;
    font-size: 120px;
    text-align: center;
    font-family: 'FeltThatW01-Regular';
    padding: 20px 0;
  }

  .BrainhubCarousel__arrows {
    background-color: transparent!important;

    span {
      display: none!important;
    }

    &:hover:enabled {
      background-color: transparent!important;
    }
  }

  .BrainhubCarousel__arrowLeft {
    background: url(https://emprendeoboticario.com.co/wp-content/themes/twentytwenty-child/images/left-arrow.svg) top center no-repeat transparent;
  }

  .BrainhubCarousel__arrowRight {
    background: url(https://emprendeoboticario.com.co/wp-content/themes/twentytwenty-child/images/right-arrow.svg) top center no-repeat transparent;
  }

  .BrainhubCarousel__dots {
    margin-top: 20px;
    button {
      background: transparent;
    }
  }

  @media(min-width: 801px) {
    .BrainhubCarousel__container {
      display: none;
    }
  }

  @media(max-width: 800px) {
    h2 {
      font-size: 65px;
    }
  }
`;

const StepGroup = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  margin-top: 30px;

  @media(max-width: 800px) {
    display: none;
  }
`;

const StepItem = styled.div`
  display: flex;
  width: 25%;
  align-items: center;
  flex-direction: column;

  img {
    width: 104px;
  }

  h3 {
    display: flex;
    align-items: center;
    color: #0a3941;
    line-height: 1;
    font-size: 31.9px;
    text-align: center;
    font-weight: 900;
    font-style: italic;
    letter-spacing: -1.91px;
    font-family: 'DomaineSansText-BlackItalic';

    span {
      color: #f2fff7;
      font-size: 72.9px;
      margin-left: 10px;
      letter-spacing: -4.38px;
      -webkit-text-stroke: 1px #009560;
    }
  }

  h4 {
    color: #027a75;
    font-size: 22px;
    line-height: 1.05;
    text-align: center;
    margin: 15px 0;
    letter-spacing: -0.88px;
    font-family: 'DomaineSansText-Medium';
  }

  p {
    color: #234757;
    font-size: 15px;
    line-height: 1.2;
    text-align: center;
    padding: 0 35px;
  }

  @media(max-width: 800px) {
    width: 100%;
  }
`;

export { StepStyle, StepGroup, StepItem };
